import React from 'react'
import "./teeth.css"
import CustomTitle from '../CustomTitle/CustomTitle.jsx'








export default function Teeth() {

   return (
      <>
      <CustomTitle title="الاسنان" />
         <div className="container">
            <h2 className='main-header mt-5 pt-5'>Teeth Profile</h2>
            <div className='under-header'></div>

            <div className="row">
               <p>Not Found Data Today`s !</p>
            </div>
         </div>
      </>
   )
}
